import { h } from 'preact'; /** @jsx h */

import './FactsList.scss';

const FactsList = ({
    title,
    href,
    linkText,
    borderColor = 'secondary',
    bgColor = 'all-white',
    btnColor = 'primary',
    children
}) => {
    return (
        <div className={`facts-container border-color-${borderColor} bg-color-${bgColor}`}>
            {title && <h3 className="facts-title">{title}</h3>}
            {children && <ul className="facts-ul">{children}</ul>}
            {href && linkText && (
                <a className={`cta-btn color-${btnColor}`} href={href}>
                    <span>
                        <span dangerouslySetInnerHTML={{ __html: linkText }} />
                    </span>
                    <span className="material-symbols-outlined">arrow_forward</span>
                </a>
            )}
        </div>
    );
};

export default FactsList;
